import React, { useState } from "react";
import { connect } from "react-redux";
import { Button } from "components/common";
import Select from "react-select";
import { useMutation } from "@apollo/react-hooks";
import { ADD_ACCOUNT } from "utils";
import { ERROR_STATUS } from "utils/constants";

import { modalBGColor } from "utils/customStyles";
import SuccessMessage from "components/Popups/Messages/SuccessMessage";

const AddAccountModal = ({ user, refetch, agent_email }) => {
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [confirmAccountErrorMessage, setConfirmAccountErrorMessage] = useState(
    ""
  );
  const [accountNumber, setAccountNumber] = useState("");
  const [accountNumberConfirmation, setAccountNumberConfirmation] = useState(
    ""
  );
  const [routingNumber, setRoutingNumber] = useState("");
  const [institution, setInstitution] = useState("");
  const [accountSpecs, setAccountSpecs] = useState({});
  const [addAccount] = useMutation(ADD_ACCOUNT);

  const MONITOR_BALANCE = false;

  const validateAccountNumbersMatch = () => {
    if (accountNumber !== accountNumberConfirmation) {
      setConfirmAccountErrorMessage(
        "Please make sure the account number confirmation matches."
      );
      return false;
    }

    setConfirmAccountErrorMessage("");
    return true;
  };

  const handleSubmit = async () => {
    setLoading(true);
    if (
      !validateAccountNumbersMatch() ||
      !routingNumber ||
      !accountNumber ||
      !accountNumberConfirmation ||
      !institution ||
      Object.keys(accountSpecs).length === 0
    ) {
      setErrorMessage("Please enter all fields");
      setLoading(false);
      return;
    }

    const res = await addAccount({
      variables: {
        user_id: parseInt(user.id, 10),
        type: accountSpecs.accountType,
        monitor_balance: MONITOR_BALANCE,
        account_number: accountNumber,
        routing_number: routingNumber,
        name: accountSpecs.name,
        institution,
        galileo_type: accountSpecs.galileoType,
        agent_email
      }
    });

    const {
      data: {
        manuallyAddAccount: { status }
      }
    } = res;

    if (status === ERROR_STATUS) {
      setErrorMessage(
        "There was an error adding the account. Please try again in 5 minutes. If this persists, please reach out to dev-support."
      );
      setLoading(false);
      return;
    }
    setLoading(false);
    setSuccess(true);
    refetch();
  };

  const handleChange = (e, fn) => {
    setErrorMessage("");
    fn(e.target.value);
  };

  const selectOptions = [
    {
      value: { galileoType: "C", name: "Checking", accountType: "checking" },
      label: "Checking"
    },
    {
      value: { galileoType: "S", name: "Savings", accountType: "savings" },
      label: "Savings"
    },
    {
      value: {
        galileoType: "M",
        name: "Money Market",
        accountType: "money market"
      },
      label: "Money Market"
    }
  ];

  return (
    <div style={modalBGColor}>
      {!success ? (
        <div
          style={{ width: "500px", height: "650px", borderRadius: "10px" }}
          className="flex flex-col justify-center items-center"
        >
          <div
            style={{ width: "100%", height: "23%" }}
            className="btn-green flex justify-center items-center"
          >
            <div className="font-bold text-3xl">Add Bank Account</div>
          </div>
          <div className="py-8 px-12 w-full h-full">
            <div className="flex mb-2">
              <div className="w-2/4 font-bold">Institution Name:</div>
              <input
                onChange={e => handleChange(e, setInstitution)}
                type="text"
                value={institution}
                placeholder="ENTER BANK"
                className="w-2/4"
              />
            </div>
            <div className="flex mb-2">
              <div className="w-2/4 font-bold">Routing Number:</div>
              <input
                onChange={e => handleChange(e, setRoutingNumber)}
                type="number"
                value={routingNumber}
                placeholder="ENTER ROUTING NUMBER"
                className="w-2/4"
              />
            </div>
            <div className="flex mb-2">
              <div className="w-2/4 font-bold">Account Number:</div>
              <input
                onChange={e => handleChange(e, setAccountNumber)}
                onKeyUp={validateAccountNumbersMatch}
                type="number"
                value={accountNumber}
                placeholder="ENTER ACCOUNT NUMBER"
                className="w-2/4"
              />
            </div>
            <div className="flex mb-2">
              <div className="w-2/4 font-bold">Confirm Account Number:</div>
              <input
                onChange={e => handleChange(e, setAccountNumberConfirmation)}
                onKeyUp={validateAccountNumbersMatch}
                type="number"
                value={accountNumberConfirmation}
                placeholder="ENTER ACCOUNT NUMBER"
                className="w-2/4"
              />
            </div>
            <Select
              className="mt-4"
              placeholder="Select Account Type"
              options={selectOptions}
              onChange={value => setAccountSpecs(value.value)}
            />
            <div className="bg-white mt-4 font-bold">
              REQUIRED SCRIPTING
              <p className="mt-4 font-bold">
                {`“I understand you authorize TomoCredit to ACH debit your account ending in ${
                  accountNumber.length >= 4 ? accountNumber.slice(-4) : "XXXX"
                } for your automatic payments for repayment of your outstanding balance.`}
              </p>
              <p className="mt-4 font-bold">
                If you have any questions about your payments, you must contact
                TomoCredit 3 business days before your scheduled payment at
                866.432.7695”
              </p>
            </div>
            <div className={errorMessage ? "text-red-600 mb-4 w-96" : "hidden"}>
              {errorMessage}
            </div>
            <div
              className={
                confirmAccountErrorMessage ? "text-red-600 mb-4 w-96" : "hidden"
              }
            >
              {confirmAccountErrorMessage}
            </div>
            <div className="flex justify-center">
              <Button
                className={`mb-6 mt-5 w-36 text-2xl btn-green ${
                  loading ? "opacity-50" : ""
                }`}
                disabled={loading}
                onClick={handleSubmit}
              >
                Submit
              </Button>
            </div>
          </div>
        </div>
      ) : (
        <SuccessMessage mainMessage="Account successfully added." />
      )}
    </div>
  );
};

const mapStateToProps = state => ({
  agent_email: state.user.id
});

export default connect(mapStateToProps, null)(AddAccountModal);